/**
 * Getters for wordpress/pages module
 */
const getters = {
  all: state => state.pages,
  published: state => state.pages.filter(page => page.status === 'publish'),
  selected: state => state.selected
}

export default getters



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/pages/getters.js